import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["input", "clear"];
  static values = { scope: { type: String, default: "app" } };

  connect() {
    this.debounceTimer = null;
    this.previousUrl = null;
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    this.toggleClearButton();

    this.debounceTimer = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  clear() {
    this.inputTarget.value = "";
    this.toggleClearButton();
    this.restorePreviousPage();
    this.inputTarget.focus();
  }

  performSearch() {
    const query = this.inputTarget.value.trim();

    if (query.length < 2) {
      this.restorePreviousPage();
      return;
    }

    if (!this.previousUrl) {
      this.previousUrl = window.location.href;
    }

    const searchUrl = `/docs/search?q=${encodeURIComponent(query)}&scope=${this.scopeValue}`;
    Turbo.visit(searchUrl, { action: "advance" });
  }

  restorePreviousPage() {
    if (this.previousUrl) {
      Turbo.visit(this.previousUrl, { action: "advance" });
      this.previousUrl = null;
    }
  }

  toggleClearButton() {
    if (this.hasClearTarget) {
      this.clearTarget.hidden = this.inputTarget.value.length === 0;
    }
  }
}
